"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatMensajeConverter = void 0;
const chatMensajeConverter = {
    toFirestore(chat) {
        return chat;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            enviadoPorFixed: data.enviadoPorFixed,
            autorNombre: data.autorNombre,
            autorUserId: data.autorUserId,
            empresaId: data.empresaId,
            clienteId: data.clienteId,
            fecha: data.fecha,
            mensaje: data.mensaje,
            vistoCliente: data.vistoCliente,
            vistoFixed: data.vistoFixed,
            urlImagenRemitente: data.urlImagenRemitente,
            notaPrivada: data.notaPrivada,
            refAdjunto: data.refAdjunto,
            urlAdjunto: data.urlAdjunto,
            nombreAdjunto: data.nombreAdjunto,
            tamanioAdjunto: data.tamanioAdjunto,
            resuelto: data.resuelto,
            reabierto: data.reabierto,
            enviadoDesde: data.enviadoDesde
        };
    }
};
exports.chatMensajeConverter = chatMensajeConverter;
